import * as Icons from "lucide-react";
import Reveal from "./Reveal";
import { VALUE_PROPS } from "@/data/content";

export default function ValueProps() {
    return (
        <section
            data-testid="value-props-section"
            className="section-y bg-accent/40 relative overflow-hidden"
        >
            <div className="container-em">
                <div className="max-w-3xl">
                    <Reveal>
                        <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                            Warum Emsglück?
                        </span>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2
                            data-testid="value-props-title"
                            className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight text-balance"
                        >
                            Mehr als nur eine Unterkunft.
                        </h2>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                    {VALUE_PROPS.map((v, i) => {
                        const Icon = Icons[v.icon] || Icons.Sparkles;
                        return (
                            <Reveal
                                key={v.title}
                                delay={i * 0.06}
                                className="h-full"
                            >
                                <div
                                    data-testid="value-prop-card"
                                    className="h-full bg-card rounded-3xl p-8 border border-border/60 hover:border-primary/40 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(60,60,50,0.2)]"
                                >
                                    <div className="w-12 h-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-6">
                                        <Icon size={22} strokeWidth={1.6} />
                                    </div>
                                    <h3 className="font-display text-2xl leading-tight text-foreground">
                                        {v.title}
                                    </h3>
                                    <p className="mt-3 text-foreground/70 leading-relaxed">
                                        {v.text}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
